module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Moonglade - Luxury Apartments in Kokapet, Hyderabad","short_name":"Moonglade","description":"Premium 3 & 4 BHK apartments in Kokapet near Financial District, Hyderabad","start_url":"/","background_color":"#FFFFFF","theme_color":"#1D256C","display":"standalone","icon":"src/assets/images/icon.png","icon_options":{"purpose":"any maskable"},"cache_busting_mode":"none","include_favicon":true,"legacy":true,"theme_color_in_head":true,"crossOrigin":"anonymous","cacheDigest":null},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
